"use strict";
/*! QuiltDraw 2.0.0 AGPL-3.0-or-later | https://github.com/sapphirecat/quilt-draw */
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("./lib/ui");
(function (fn) {
    if (document.readyState !== "loading") {
        fn();
    }
    else {
        document.addEventListener("DOMContentLoaded", fn);
    }
})(ui_1.initJs);
